import { render } from "./ProfileSelect.vue?vue&type=template&id=0b2a475f"
import script from "./ProfileSelect.vue?vue&type=script&lang=js"
export * from "./ProfileSelect.vue?vue&type=script&lang=js"

import "./ProfileSelect.vue?vue&type=style&index=0&id=0b2a475f&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__